import { Box } from "@chakra-ui/layout";
import React from "react";
import ReactSVG from "../ReactSVG";

export const PageIntro: React.FC<{
  title: string;
  content: string;
  iconPath: string;
}> = ({ title, content, iconPath }) => (
  <Box mx={{ base: "-15px", sm: "0" }} className="p-4 bg-blue-9 md:flex md:justify-between md:items-center md:px-14 md:py-7">
    <div>
      <h1 className="text-l md:text-xxl font-bold mb-4 text-black">{title}</h1>
      <p className="text-base leading-snug font-serif md:font-sans text-black-1 md:text-grey-8 md:text-m md:font-semibold md:leading-7">
        {content}
      </p>
    </div>
    <div className="hidden md:flex bg-white rounded-full w-16 h-16 shadow-1 justify-center items-center flex-shrink-0">
      <ReactSVG className="w-8" path={iconPath} />
    </div>
  </Box>
);
